export const MOVE_BRASIL_MODEL_COLORS = [
	{
		id: "branco",
		name: "Branco",
		swatch: "/images/move-brasil/colors/branco.svg",
		image: "/images/move-brasil/model/branco.jpg",
	},
	{
		id: "azul",
		name: "Azul",
		swatch: "/images/move-brasil/colors/azul.svg",
		image: "/images/move-brasil/model/azul.jpg",
	},
	{
		id: "preto",
		name: "Preto",
		swatch: "/images/move-brasil/colors/preto.svg",
		image: "/images/move-brasil/model/preto.jpg",
	},
	{
		id: "cinza",
		name: "Cinza",
		swatch: "/images/move-brasil/colors/cinza.svg",
		image: "/images/move-brasil/model/cinza.jpg",
	},

] as const;

export const MOVE_BRASIL_MODEL_SPECS = [
	{
		label: "MOTOR",
		value:
			"1.3 Turbo Flex (T270) híbrido leve (MHEV) para reduzir o consumo.",
	},
	{
		label: "TIPO DE COMBUSTÍVEL",
		value:
			"Gasolina e etanol, para escolher o combustível mais vantajoso.",
	},
	{
		label: "CAPACIDADE",
		value: "Acomoda confortavelmente até 5 ocupantes.",
	},
	{
		label: "DESEMPENHO",
		value:
			"27,5 kgfm de torque para respostas rápidas nas acelerações e retomadas.",
	},
	{
		label: "TRANSMISSÃO",
		value: "Câmbio automático de 6 marchas com trocas suaves.",
	},
] as const;
